import { render, staticRenderFns } from "./live-desc.vue?vue&type=template&id=1be5721e&scoped=true&"
import script from "./live-desc.vue?vue&type=script&lang=ts&"
export * from "./live-desc.vue?vue&type=script&lang=ts&"
import style0 from "./live-desc.vue?vue&type=style&index=0&id=1be5721e&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be5721e",
  null
  
)

export default component.exports